import React from 'react';
import {useStaticQuery, graphql} from 'gatsby'
//@ts-ignore
import styles from './hero.module.css'
import { openPopupWidget } from 'react-calendly';

export interface IHeroProps {
    text: {
        name: string;
        content : {
            content : string;
        }
    },
    buttonData: {
        url: string;
        buttonText: string;
    }
}

const useHeroTextAndTitle = () => {
    const data = useStaticQuery(
        graphql`
        query HeroData {
            allContentfulTargetedText(filter: {name: {in: ["hero title", "hero text"]}}) {
              nodes {
                name
                content {
                  content
                }
              }
            }
            contentfulAsset(title: {eq: "hero-image"}) {
              file {
                url
              }
            }
          }
      ` 
    );
    const heroText = data?.allContentfulTargetedText?.nodes?.find(node => node?.name === "hero text");
    const heroTitle = data?.allContentfulTargetedText?.nodes?.find(node => node?.name === "hero title");
    const imageUrl = data?.contentfulAsset?.file?.url;
    return {heroText: heroText?.content?.content, heroTitle: heroTitle?.content?.content, imageUrl}
}
export const Hero: React.FunctionComponent<IHeroProps> = (props) => {
    const {buttonData} = props

    const {heroText, heroTitle, imageUrl} = useHeroTextAndTitle();

    const openCalendly = () => {
        openPopupWidget({url: buttonData?.url})
    }
    
    return(
        <div className={styles.heroContainer}>
            <div className={styles.imgBox}>
                <img src={imageUrl}></img>
            </div>
            <div className={styles.hero}>
                <div className={styles.textBox}>
                   <div className={styles.titleBox}>
                        {heroTitle}
                    </div>    
                    <div className={styles.textBox}>
                        {heroText}
                    </div>
                    <div className={styles.bookAdemo} onClick={openCalendly}>
                        {/* <a href={buttonData.url}>{buttonData.buttonText}</a> */}
                        <div>{buttonData.buttonText}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}